import Details from "./Details";
import List from "./List";

export default { List, Details };
